import { render } from "./EmailTemplateManagement.vue?vue&type=template&id=55aea058&scoped=true&ts=true"
import script from "./EmailTemplateManagement.vue?vue&type=script&lang=ts"
export * from "./EmailTemplateManagement.vue?vue&type=script&lang=ts"

import "./EmailTemplateManagement.vue?vue&type=style&index=0&id=55aea058&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55aea058"]])

export default __exports__